module.exports = __webpack_public_path__ + "static/media/nutritionIconHover.dd2a4d3f.svg";